export default __webpack_public_path__ + "static/hurricane-3a6ca15b186947548f79c072120f6b25.png";